import { render, staticRenderFns } from "./PersonIdentificationDetails.vue?vue&type=template&id=23e0fe98&scoped=true"
import script from "./PersonIdentificationDetails.vue?vue&type=script&lang=js"
export * from "./PersonIdentificationDetails.vue?vue&type=script&lang=js"
import style0 from "./PersonIdentificationDetails.vue?vue&type=style&index=0&id=23e0fe98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0fe98",
  null
  
)

export default component.exports